<template>

</template>

<script>
    import ss from '../api/SystemService';
    import store from "../store";
    export default {
        data(){
            return {
                url: 'http://omstest.haierbiomedical.com',
            }
        },
        created() {
            this.loading = true;
            this.toRescue();
        },
        methods: {
            toRescue() {
                var code = this.$route.query.code;
                ss.UserAuthService.getCluesSignToken(code).then(rd => {
                    if(rd.f == true){
                        store.commit("setUser", rd)
                        this.loading = false;
                        this.$router.push({path: rd.obj.defaultpage});
                    }
                })
            },
        },
    }
</script>

<style scoped>

</style>